import { render, staticRenderFns } from "./InvoicePersonTypeView.vue?vue&type=template&id=2c1f2858&scoped=true&"
import script from "./InvoicePersonTypeView.vue?vue&type=script&lang=ts&"
export * from "./InvoicePersonTypeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f2858",
  null
  
)

export default component.exports